import { render, staticRenderFns } from "./GiteaSaveModal.vue?vue&type=template&id=d40770e2&"
import script from "./GiteaSaveModal.vue?vue&type=script&lang=js&"
export * from "./GiteaSaveModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "GiteaSaveModal.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/modals/providers/GiteaSaveModal.vue
// module id = 2354
// module chunks = 1